module.exports = __webpack_public_path__ + "static/media/proj11_img2.84fd4a74.jpg";